'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Emitter = function () {
  (0, _createClass3.default)(Emitter, null, [{
    key: 'parseEventMessage',
    value: function parseEventMessage(message) {
      var _split = (typeof message === 'string' ? message : '').split('|'),
          _split2 = (0, _slicedToArray3.default)(_split, 2),
          eventName = _split2[0],
          payload = _split2[1];

      return { eventName: eventName, payload: payload };
    }
  }]);

  function Emitter() {
    (0, _classCallCheck3.default)(this, Emitter);

    this._listeners = [];
    this._setupListeners();
  }

  (0, _createClass3.default)(Emitter, [{
    key: '_setupListeners',
    value: function _setupListeners() {
      var _this = this;

      window.addEventListener('message', function (e) {
        var _Emitter$parseEventMe = Emitter.parseEventMessage(e.data),
            eventName = _Emitter$parseEventMe.eventName,
            payload = _Emitter$parseEventMe.payload;

        if (!eventName) {
          return;
        }

        _this._listeners.filter(function (_ref) {
          var name = _ref.name;
          return name === eventName;
        }).forEach(function (_ref2) {
          var name = _ref2.name,
              callback = _ref2.callback,
              once = _ref2.once;

          callback(e, payload);

          if (once) {
            _this.removeListener(name, callback);
          }
        });
      });
    }
  }, {
    key: 'listen',
    value: function listen(name, callback) {
      var _this2 = this;

      this._listeners.push({
        name: name,
        callback: callback
      });

      return function () {
        _this2.removeListener(name, callback);
      };
    }
  }, {
    key: 'listenOnce',
    value: function listenOnce(name, callback) {
      var _this3 = this;

      this._listeners.push({
        name: name,
        callback: callback,
        once: true
      });

      return function () {
        _this3.removeListener(name, callback);
      };
    }
  }, {
    key: 'removeListener',
    value: function removeListener(event, callback) {
      this._listeners = this._listeners.filter(function (listener) {
        return listener.name !== event && listener.callback !== callback;
      });
    }
  }, {
    key: 'emit',
    value: function emit(event) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.parent;
      var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '*';

      if (target) {
        target.postMessage(event + '|' + payload, origin);
      }
    }
  }]);
  return Emitter;
}();

exports.default = Emitter;